/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable camelcase */
/* eslint-disable consistent-return */
/* eslint-disable no-promise-executor-return */
import { v4 as uuidv4 } from "uuid";
import { MediaPermissionsErrorType } from "mic-check";
import { requestVideoPermissions } from "mic-check/lib/requestMediaPermissions";
import { posthog } from "posthog-js";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";
import jwtDecode from "jwt-decode";
import {
	API_ENDPOINTS,
	CLOTHING_BANNER_SCAN,
	CLOTHING_CUSTOM_FIT_SCAN,
	CLOTHING_CUSTOM_SCAN,
	CLOTHING_SCAN,
	CLOTHING_TRYON_CONSUMER_SCAN,
	CUSTOM_STORES,
	IdntfyStore,
	MYKNITEVER_DOMAIN,
	TEST_SWAN_EXT_DOMAIN,
	REACT_APP_AUTH0_AUDIENCE,
	REACT_APP_AUTH0_CLIENT_ID,
	REACT_APP_AUTH0_DOMAIN,
	REACT_APP_ADIDAS_DEMO_STORE_DOMAIN,
	REACT_APP_CONSUMER_TRYON_DOMAIN,
	REACT_APP_CUSTOM_SCAN_REDIRECT_URL,
	SESSION_STORAGE_KEY,
	SWAN_VISION_AI,
	TOKEN_DATA_TYPE,
} from "../vars";
import apiClient from "../service/apiService";

export const timeout = (callback, delay) =>
	setTimeout(() => {
		callback();
	}, delay);
export const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time));

export function setLocalStorageData(key, value) {
	localStorage.setItem(key, JSON.stringify(value));
}
export const decodeStoredToken = (token) => {
	try {
		const jwtToken = token ?? getLocalStorageData(SESSION_STORAGE_KEY.JWTToken);
		const decode = jwtDecode(jwtToken);
		const currentDate = new Date();
		if (decode && decode.exp && decode.exp * 1000 < currentDate.getTime()) {
			return false;
		}
		return decode;
	} catch {
		return false;
	}
};

export function getLocalStorageData(key) {
	try {
		return JSON.parse(localStorage.getItem(key) ?? "");
	} catch {
		return null;
	}
}
export const removeLocalStorage = (key) => {
	localStorage.removeItem(key);
};

export const isValidEmail = (email) => {
	const checkEmailValidation = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return checkEmailValidation.test(email);
};

export function convertToCentimeters(feet, inches) {
	const feetToCentimeters = (feet && +feet * 30.48) ?? 0;
	const inchesToCentimeters = (inches && +inches * 2.54) ?? 0;
	const totalCentimeters = feetToCentimeters + inchesToCentimeters;
	return totalCentimeters;
}

export function generateUuid() {
	return uuidv4();
}

export function toSetAndRemoveParams({
	url = window.location.origin,
	email = getSessionStorage(SESSION_STORAGE_KEY.EMAIL),
	shopifyRedirectUrl = getSessionStorage(SESSION_STORAGE_KEY.SHOPIFY_REDIRECT_URL),
	shopDomain = getSessionStorage(SESSION_STORAGE_KEY.SHOP_DOMAIN),
	// storeName = getSessionStorage(SESSION_STORAGE_KEY.STORE_NAME),
	token= getLocalStorageData(SESSION_STORAGE_KEY.JWTToken),
	callbackUrl = getSessionStorage(SESSION_STORAGE_KEY.CALLBACK_URL),
	source = getSessionStorage(SESSION_STORAGE_KEY.SOURCE),
} = {}) {
	if (!url) return;
	try {
		const newUrl = new URL(url);
		const searchParams = new URLSearchParams(newUrl.search);
		const params = {
			// store_name: storeName,
			email,
			shop_domain: shopDomain,
			shopify_redirect: shopifyRedirectUrl,
			callback_url: callbackUrl,
			source,
			token
		};
		Object.entries(params).forEach(([key, value]) => {
			if (value) searchParams.set(key, value);
		});
		return `${newUrl.origin}/?${searchParams.toString()}`;
	} catch (err) {
		console.log(err);
	}
}
export const createRedirectUrl = ({ url, email }) => {
	const newUrl = new URL(url);
	const searchParams = new URLSearchParams(newUrl.search);
	if (email) {
		searchParams.set("email", email);
	}
	// if (scanId) {
	// 	searchParams.set("scan_id", scanId);
	// }
	if (newUrl.pathname && newUrl.pathname !== "/") {
		return `${newUrl.origin}${newUrl.pathname}?${searchParams.toString()}`;
	}
	return `${newUrl.origin}/?${searchParams.toString()}`;
};
export function encodingURL(url) {
	return encodeURIComponent(url);
}
export function decodingURL(url) {
	return decodeURIComponent(url);
}

export function capitalizeFirstLetter(string = "") {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export async function checkCameraPermission() {
	try {
		await requestVideoPermissions();
		return { disabled: false, message: false };
	} catch (err) {
		const { type } = err;
		if (type === MediaPermissionsErrorType.Generic || type === MediaPermissionsErrorType.CouldNotStartVideoSource) {
			return { disabled: true, message: true };
		}
		if (type === MediaPermissionsErrorType.SystemPermissionDenied || type === MediaPermissionsErrorType.UserPermissionDenied) {
			return { disabled: true, message: false };
		}
		// Return a distinct response for any other errors
		return { disabled: true, message: "An unknown error occurred" };
	}
}
export function detectBrowserFunction() {
	const browserInfo = navigator.userAgent;
	let browser;
	if (browserInfo.includes("Opera") || browserInfo.includes("Opr")) {
		browser = "Opera";
	} else if (browserInfo.includes("Edg")) {
		browser = "Edge";
	} else if (browserInfo.includes("Chrome") || navigator.vendor.toLowerCase().includes("google")) {
		browser = "Chrome";
	} else if (browserInfo.includes("Safari")) {
		browser = "Safari";
	} else if (browserInfo.includes("Firefox")) {
		browser = "Firefox";
	} else {
		browser = "Browser";
	}
	return browser;
}

export const rescanSupportCaptureEvent = ({ event, scanID, status = false, gender, email, height }) => {
	const timestamp = new Date().toISOString();
	const prop = { scanID, timestamp, email, ...(height ? { height } : {}), ...(gender ? { gender } : {}), ...(status ? { status } : {}) };
	posthog.capture(event, prop);
};

export const getCurrentTimeInSeconds = () => Math.round(Date.now() / 1000);

export const getScanType = (scanType) => {
	switch (scanType) {
		case CLOTHING_CUSTOM_SCAN:
		case CLOTHING_TRYON_CONSUMER_SCAN:
			return CLOTHING_CUSTOM_SCAN;
		case CLOTHING_CUSTOM_FIT_SCAN:
			return CLOTHING_CUSTOM_SCAN;
		case CLOTHING_BANNER_SCAN:
			return CLOTHING_BANNER_SCAN;
		default:
			return CLOTHING_SCAN;
	}
};
export function handleWebSocketCapture({ event, scanID, connection, type, email, faceScanID }) {
	const timestamp = new Date().toISOString();
	const payload = { connection, ...(scanID ? { scanID } : {}), timestamp, type, ...(faceScanID ? { faceScanID } : {}) };
	if (email) {
		payload.email = email;
	}
	posthog.capture(event, payload);
}

export function hasNullValue(prop) {
	const searchParams = new URLSearchParams(window.location.search);
	return searchParams.has(prop) && searchParams.get(prop) !== "null" && searchParams.get(prop) !== "undefined";
}
export function hasNullSessionValue(prop) {
	const value = getSessionStorage(prop);
	return value && value !== "null" && value !== "undefined";
}
export function getParamsValue(prop) {
	const searchParams = new URLSearchParams(window.location.search);
	return searchParams.get(prop);
}

export function createCustomUrl({ storeUrl, name, email, storeName, redirectUrl, shopifyRedirectUrl, gender, productName, callbackUrl, source }) {
	const params = new URLSearchParams({
		shop_domain: storeUrl,
		scan_type: CLOTHING_CUSTOM_FIT_SCAN,
	});
	if (name) params.set("name", name);
	if (email) params.set("email", encodingURL(email));
	if (storeName) params.set("store_name", storeName);
	if (gender) params.set("gender", gender);
	if (productName) params.set("product_name", productName);
	if (callbackUrl) params.set("callback_url", callbackUrl);
	if (source) params.set("source", source);

	if (redirectUrl || CUSTOM_STORES.includes(storeUrl) || shopifyRedirectUrl) {
		params.set("shopify_redirect", redirectUrl || shopifyRedirectUrl || `https://${storeUrl}`);
	}
	// return params.toString();
	return `${REACT_APP_CUSTOM_SCAN_REDIRECT_URL}/?${params.toString()}`;
}

export function handleScanTimeCapture({ event, scanID, status, completionTime = 0, email = "", message = "", data, faceScanID }) {
	const timestamp = new Date().toISOString();

	const payload = Object.fromEntries(
		Object.entries({
			timestamp,
			status,
			scanID,
			faceScanID,
			email,
			completionTime,
			message,
			data,
		}).filter(([, value]) => value !== undefined && value !== "" && value !== 0),
	);

	posthog.capture(event, payload);
}

let id = 0;
export const copyToClipboard = (text, innerText) => {
	clearTimeout(id);
	navigator.clipboard.writeText(text).then(
		() => {
			const button = document.getElementById("copy-button");
			if (button) {
				button.innerText = "Copied to clipboard";
				id = setTimeout(() => {
					button.innerText = innerText;
				}, 2000);
			}
		},
		(err) => {
			console.error("Async: Could not copy text: ", err);
		},
	);
};

export const handlePostHogCustomEvent = (event, payload) => {
	posthog.capture(event, payload);
};

export const setSessionStorage = (key, value) => {
	try {
		sessionStorage.setItem(key, value);
	} catch (err) {
		console.log(err, "while storing in session");
	}
};
export const removeSessionStorage = (key) => {
	try {
		sessionStorage.removeItem(key);
	} catch (err) {
		console.log(err, "while removing item in session");
	}
};

export const getSessionStorage = (key) => {
	try {
		return sessionStorage.getItem(key);
	} catch (err) {
		console.log(err, "while getting value from session");
		return null;
	}
};
export const handleErrorMessage = (error) =>
	error?.response?.data?.error ?? error?.response?.data?.message ?? error?.response?.data?.details?.[0]?.message ?? error?.message ?? error?.error ?? "Something went wrong";

export const checkSessionTime = (email, scanID, shopDomain) => {
	const sessionStartTime = sessionStorage.getItem(SESSION_STORAGE_KEY.SESSION_TIME);
	if (sessionStartTime) {
		const currentTime = new Date().getTime();
		const sessionDuration = currentTime - parseInt(sessionStartTime, 10);
		const hoursElapsed = sessionDuration / (1000 * 60 * 60);
		if (hoursElapsed > 2) {
			handleScanTimeCapture({ event: `${shopDomain}/session_timeout_exceeded`, scanID, email, message: "Session timeout exceeded for more than 2 hrs" });
			setSessionStorage(SESSION_STORAGE_KEY.SESSION_TIME, currentTime.toString());
		}
	} else {
		const startTime = new Date().getTime();
		setSessionStorage(SESSION_STORAGE_KEY.SESSION_TIME, startTime.toString());
	}
};
export function trackVisibilityChanges() {
	try {
		if (typeof document.visibilityState !== "undefined") {
			// Add event listener for visibility changes
			document.addEventListener("visibilitychange", () => {
				// eslint-disable-next-line prefer-destructuring
				const visibilityState = document.visibilityState;
				posthog.capture("visibility_change", {
					state: visibilityState,
					timestamp: new Date().toISOString(),
				});

				// Optional: Log state change in the console (for debugging)
				console.log(`Tab is now ${visibilityState}`);
			});
		} else {
			console.warn("Visibility API not supported by this browser.");
		}
	} catch (err) {
		console.log(err, "while visibility check");
	}
}
export const handleCheckSessionStorage = () => {
	const email = getSessionStorage(SESSION_STORAGE_KEY.EMAIL);
	const shopDomain = getSessionStorage(SESSION_STORAGE_KEY.SHOP_DOMAIN);
	const gender = getSessionStorage(SESSION_STORAGE_KEY.GENDER);
	const height = getSessionStorage(SESSION_STORAGE_KEY.HEIGHT);
	const focalLength = getSessionStorage(SESSION_STORAGE_KEY.FOCAL_LENGTH);
	const scanType = getSessionStorage(SESSION_STORAGE_KEY.SCAN_TYPE);

	const variables = { email, shopDomain, gender, height, focalLength, scanType };
	const missingVars = [];
	Object.entries(variables).forEach(([key, value]) => {
		if (!value || value === "null" || value === "undefined") {
			console.log(`${key} is missing`);
			missingVars.push(key);
		}
	});

	if (missingVars.length > 0) {
		posthog.capture("session_storage", {
			message: `Redirecting because didn't find these variables in session storage : ${missingVars.join(", ")}`,
			timestamp: new Date().toISOString(),
			email,
		});
		window.location.href = SWAN_VISION_AI; // Redirect to an error page or any other appropriate page
	}
};
export const clearSessionTimeAndScanId = () => {
	removeSessionStorage(SESSION_STORAGE_KEY.SCAN_TIME);
	removeSessionStorage(SESSION_STORAGE_KEY.SCAN_ID);
};

export function formatDate(dateString) {
	const date = new Date(dateString);
	const day = date.getUTCDate();
	const month = date.toLocaleString("default", { month: "long" });
	const year = date.getUTCFullYear();
	const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;
	return `${dayWithSuffix} ${month} ${year}`;
}

function getOrdinalSuffix(day) {
	if (day > 3 && day < 21) return "th";
	switch (day % 10) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
}

export function cn(...inputs) {
	return twMerge(clsx(inputs));
}

// export const getLogourl = (productUrl) => {
// 	if (!productUrl) {
// 		return "";
// 	}
// 	return `https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${productUrl}&size=32`;
// };

export const getShopType = (shopDomain) => {
	switch (shopDomain) {
		case IdntfyStore:
			return { isIdntfy: true };
		case REACT_APP_CONSUMER_TRYON_DOMAIN:
			return { isConsumerTryon: true };
		case MYKNITEVER_DOMAIN:
			return { isMyknitever: true };
		case TEST_SWAN_EXT_DOMAIN:
			return { isSwanExt: true };
		case REACT_APP_ADIDAS_DEMO_STORE_DOMAIN:
			return { isAdidasDemoStore: true };
		default:
			return { isIdntfy: false, isConsumerTryon: false, isMyknitever: false, isAdidasDemoStore: false, isSwanExt: false };
	}
};
export const handleGetUserDetails = () =>
	apiClient.get(API_ENDPOINTS.profile.userProfile, {
		headerToken: TOKEN_DATA_TYPE.ACCESS,
	});
export const handlePostUserDetails = (user) =>
	apiClient.post(
		API_ENDPOINTS.profile.userProfile,
		{ ...user },
		{
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		},
	);
export const handleUserExistance = (email) => apiClient.get(`${API_ENDPOINTS.profile.userExists}/${email}`);
export const getOriginFromUrl = (url) => {
	try {
		return new URL(url).origin;
	} catch (e) {
		return "";
	}
};

export const getAuth0Options = (orgId) => ({
	domain: REACT_APP_AUTH0_DOMAIN,
	clientId: REACT_APP_AUTH0_CLIENT_ID,
	authorizationParams: {
		redirect_uri: typeof window !== "undefined" ? `${window.location.origin}/auth/callback` : "",
		audience: REACT_APP_AUTH0_AUDIENCE,
		scope: "openid profile email offline_access",
		...(orgId ? { organization: orgId } : {}),
	},
	useRefreshTokens: true, // rotate RTs (works across Safari/Firefox)
	cacheLocation: "localstorage", // persist across reloads
	useRefreshTokensFallback: false,
});
